<template>
    <div class="single-job-inline-container">
        <router-link to="/" class="close"></router-link>
        <div class="job" >
            <h1>We can't find that job {{ id }}.</h1>
            <p>It may have been removed or the id is invalid.</p>
            <p><router-link to="/">Back to all jobs</router-link></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'JobInlineMissing',
        props : [ 'id' ]
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";

    .single-job-inline-container{
        margin: 0.5rem 1.25rem;
        border-radius: $radius;
        padding: 2rem 4rem;
        background: white;
        flex-basis: 50%;
        flex-shrink: 0;
        z-index: 100;
        position: relative;
    }

    .close{
        display: block;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        position: absolute;
        right: 1rem;
        top: 1rem;
        cursor: pointer;
        margin-left: auto;
        background-image: url( "../assets/close.svg" );
        background-color: white;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40%;
    }

</style>
